
function f(path, name) {
    let t = `${path}/${name}`;
    let c;
    let r = () => import(`@/${t}.vue`);
    return r;
}

window.importVueComp = f;
